import * as React from "react";
const Down = (props) => (
  <svg
    width={12}
    height={7}
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 0.523437L5.95313 5.47656L10.9063 0.523438"
      stroke="#276AA6"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default Down;